<template>
  <div class="vue-warpper" style="transform-origin: 0 0">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.fnResize();
    window.onresize = () => {
      this.fnResize();
    };
  },
  methods: {
    addKefu(){
      const p = Array.from(document.documentElement.getElementsByClassName("vue-warpper"))[0]
      let aa = document.getElementById("header2")
      const transform = `scale(1)`;
      aa.style.transform = transform;
      aa.parentNode.removeChild(aa)
      aa.style.zoom = 1
      p.parentNode.insertBefore(aa, p)
    },
    addKefu2(){
      const p = Array.from(document.documentElement.getElementsByClassName("vue-warpper"))[0]
      let aa = document.getElementById("header2")
      // p.parentNode.insertBefore(a, p)
      aa.style.zoom = 0.25
      p.parentNode.insertBefore(aa, p)
    },
    fnResize() {
      let offsetWidth = document.documentElement.clientWidth;
      let element = document.documentElement.getElementsByClassName("vue-warpper")[0];
      element.style.height = offsetHeight + "px";
      if (offsetWidth > 1100) {
        element.style.width = "100%";
        element.style.transform = `scale(1)`;
        this.addKefu();
        return;
      }
      let width = "1600";

      let offsetHeight = document.documentElement.clientHeight;

      let scaleX = offsetWidth / width;

      //核心代码
      const transform = `scale(${scaleX})`;
      element.style.width = width + "px";
      element.style.transform = transform;
      this.addKefu2();
      // document.style.zoom = 0.25
      return;
      const deviceWidth =
        document.documentElement.clientWidth || window.innerWidth;
      let fontSize = deviceWidth / 19.2;
    },
  },
};
</script>

<style>
@import "./styles/default.css"; 
@import "./styles/common.css"; 
@import "./styles/animate.min.css";
html {
  /* overflow-y: scroll; */
  overflow: scroll;
  font-size: 100px;
}
.el-message__content{
  font-size:15px
}
input[type="button"],
input[type="submit"],
input[type="reset"],
input[type="text"],
input[type="tel"] {
  border-radius: 5px;
}
.el-table .cell {
  /* white-space: pre-line; */
}
.el-progress-bar__outer {
  background: #e6dbd8;
}
.el-progress-bar__innerText {
  font-weight: bold;
  font-size: 0.14rem;
}
.el-progress-bar__inner {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue